import styled from 'styled-components';

import { Card } from '@hero/atoms';

const AuthWrapper = styled.div`
  background-color: var(--color-accent-primary-weakest);
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;

  .page-wrapper {
    background-color: var(--color-accent-primary-weakest);
    height: 100%;
    max-width: 100%;
  }

  .footer {
    background-color: var(--color-accent-primary-weakest);
  }

  .error-box {
    align-items: flex-start;
    background: var(--color-error-weaker);
    border-radius: var(--size-border-radius-md);
    color: var(--color-fg-default);
    display: flex;
    flex-direction: row;
    font-size: 16px;
    justify-content: center;
    line-height: 24px;
    margin-bottom: 16px;
    margin-top: 16px;
    padding: 8px 16px;
    text-align: center;
  }
`;

const AuthCard = styled(Card)`
  border: 1px solid var(--color-accent-primary-weakest);
  box-shadow: none;
  padding: 24px 32px;
`;

const AuthLayoutHeader = styled.div`
  display: flex;
  justify-content: center;
`;

const AuthLayoutNav = styled.div`
  align-items: center;
  display: flex;
`;

const AuthLayoutNavText = styled.span`
  color: var(--color-accent-primary-default);
  font-size: 18px;
  line-height: 27px;
  margin-right: 4px;

  svg {
    height: 24px;
    width: 24px;
  }
`;

const AuthLayoutBody = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: 40px;

  ${Card.S.Wrapper} {
    min-width: 464px;
  }
`;

const AuthLayoutTitle = styled.div`
  font-size: 32px;
`;

const AuthLayoutSubtitle = styled.div`
  font-size: 18px;
  font-weight: 300;
  margin: 8px 0 40px 0;
`;

export {
  AuthCard,
  AuthLayoutBody,
  AuthLayoutHeader,
  AuthLayoutNav,
  AuthLayoutNavText,
  AuthLayoutSubtitle,
  AuthLayoutTitle,
  AuthWrapper
};
